"use client";

import { Activity, Globe, Zap, Shield, BarChart3, Bell } from "lucide-react";

const features = [
    {
        icon: Activity,
        title: "Iconic Smoke Graphs",
        description:
            "Percentile-based latency visualization that shows the full distribution — not just averages. See jitter, outliers, and trends at a glance.",
    },
    {
        icon: Globe,
        title: "Distributed Agents",
        description:
            "Deploy lightweight probe agents anywhere. Monitor from multiple vantage points with automatic scheduling and failover.",
    },
    {
        icon: Zap,
        title: "Multi-Protocol Probes",
        description:
            "ICMP, TCP, HTTP, and DNS probes out of the box. Measure what matters — latency, packet loss, response codes, DNS resolution.",
    },
    {
        icon: Bell,
        title: "Smart Alerting",
        description:
            "Threshold-based alerts with severity levels. Notify via Slack, Discord, email, or webhooks. No alert fatigue — you set the rules.",
    },
    {
        icon: BarChart3,
        title: "Built for Teams",
        description:
            "Multi-tenant by design. Role-based access, audit logs, and team invites. Every team member sees what they need.",
    },
    {
        icon: Shield,
        title: "EU-Hosted, GDPR-Native",
        description:
            "Runs on European infrastructure. No GAFAM, no vendor lock-in. Your monitoring data stays in the EU. Period.",
    },
];

export function Features() {
    return (
        <section id="features" className="relative py-24 md:py-32">
            <div className="container mx-auto px-4">
                <div className="mb-14 text-center">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                        Everything you need to{" "}
                        <span className="text-primary">monitor</span>
                    </h2>
                    <p className="mx-auto mt-3 max-w-lg text-muted-foreground">
                        Batteries included. No config files, no YAML, no PhD in observability required.
                    </p>
                </div>

                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {features.map((feature) => (
                        <div
                            key={feature.title}
                            className="group rounded-xl border border-border/30 bg-card/20 p-6 transition-all duration-300 hover:border-primary/20 hover:bg-card/40"
                        >
                            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary/15">
                                <feature.icon className="h-5 w-5" />
                            </div>
                            <h3 className="mb-2 text-base font-semibold">
                                {feature.title}
                            </h3>
                            <p className="text-sm leading-relaxed text-muted-foreground">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
